/**
 * This class is used for Windows Printing
 */
export default class Print {
    constructor() {
        this.printBlock = document.querySelector("#print-block");
        this.load = this.load.bind(this);

        document.querySelectorAll(".print-pax-card").forEach((element) => {
            element.addEventListener("click", this.load);
        });

        document.querySelectorAll(".print").forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                window.print();
            });
        });
    }

    load(event) {
        fetch(event.target.dataset.url, {
            credentials: "include",
            headers: {
                "Content-Type": "application/html",
            },
        }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            } else {
                return response.text();
            }
        }).then((text) => {
            this.printBlock.innerHTML = text;
        }).then(() => {
            window.print();
        }).catch((error) => {
            console.log(error.toString());
        });
    }
}
